"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const CloseIcon = (props) => {
    return (react_1.default.createElement(core_1.SvgIcon, Object.assign({}, props),
        react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 7.072 7.071" },
            react_1.default.createElement("g", { id: "Group_644", "data-name": "Group 644", transform: "translate(-650.964 -703.964)" },
                react_1.default.createElement("rect", { id: "Rectangle_188", "data-name": "Rectangle 188", width: "1", height: "9", rx: "0.5", transform: "translate(657.328 703.964) rotate(45)" }),
                react_1.default.createElement("rect", { id: "Rectangle_189", "data-name": "Rectangle 189", width: "1", height: "9", rx: "0.5", transform: "translate(650.965 704.671) rotate(-45)" })))));
};
exports.default = CloseIcon;
